<!-- Start Login Area -->
<div class="login-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="login-form">
                <div class="logo">
                    <!-- <a href="/">
                        <img src="../../../../../assets/img/logo-servicios-gt-name.svg" class="logo-Servicios" alt="">
                    </a> -->
                    <app-logo-name-color></app-logo-name-color>
                </div>

                <h2>Bienvenido</h2>
                <p class="font-weight-normal">Ingresa tus datos para acceder</p>
                <form [formGroup]="formLogin" (ngSubmit)="sendDataUser()">
                    <div class="form-group">
                        <input type="text" formControlName="email" class="form-control" name="email" placeholder="Correo">
                        <span class="label-title"><i class='bx bx-envelope'></i></span>
                    </div>

                    <div class="form-group">
                        <input type="password" formControlName="password" class="form-control" name="password" placeholder="Contraseña">
                        <span class="label-title"><i class='bx bx-lock'></i></span>
                    </div>

                    <div class="row mt-0" *ngIf="isUsedCodeVerify && showCodeInput">
                        <div class="col-12 text-center mb-1">
                            <span>Ingresa el código de verificación enviado.</span>
                        </div>
                    </div>
                    <div class="code-container mb-0" *ngIf="isUsedCodeVerify && showCodeInput">
                        <input
                            *ngFor="let control of digits.controls; let i = index"
                            [formControl]="control"
                            maxlength="1"
                            id="digit-{{i}}"
                            type="text"
                            inputmode="numeric"
                            class="digit-box"
                            (input)="onInput($event, i)"
                            (keydown)="onKeyDown($event, i)"
                        />
                    </div>
                    <div class="row mt-0" *ngIf="isUsedCodeVerify && showCodeInput">
                        <div class="col-12 text-center mb-0">
                            <p>No has recibido el código? <a class="resend-btn" (click)="sendCode()">Reenviar código</a></p>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="remember-forgot">
                            <label class="checkbox-box">Recuerdame
                                <input type="checkbox">
                                <span class="checkmark"></span>
                            </label>
                            <a routerLink="/authentication/forgot-password" class="forgot-password">¿Olvidaste tu
                                contraseña?</a>
                        </div>
                    </div>
                    <div class="alert alert-danger" style="display: none;" [class.shake-horizontal]="incorrectCredentials" role="alert">
                        <i class="bx bxs-error"></i> Credenciales no reconocidas
                    </div>
                    <button type="submit" [disabled]="!formLogin.valid" class="login-btn btn"><div *ngIf="waitLogin" class="spinner-border" role="status">
                    </div> <span *ngIf="!waitLogin">Entrar</span></button>

                    <p class="mb-0">¿No tienes una cuenta? <a routerLink="/authentication/register">Registrate</a></p>
                    <p class="mb-0">¿No llegó tu email de confirmación de cuenta? <a
                            routerLink="/authentication/resend-confirmation">Reenviar</a></p>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- End Login Area -->